
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
        >
          <div className="max-w-4xl mx-auto bg-dark-card border border-dark-border rounded-xl p-5 md:p-6 shadow-2xl">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <i className="ri-cookie-line text-orange-primary text-xl w-5 h-5 flex items-center justify-center"></i>
                  <h3 className="text-text-primary font-semibold text-base">Uso de cookies</h3>
                </div>
                <p className="text-text-muted text-sm leading-relaxed">
                  Utilizamos cookies propias y de terceros para mejorar tu experiencia de navegación, 
                  analizar el tráfico del sitio y personalizar el contenido. Al hacer clic en "Aceptar", 
                  consientes el uso de todas las cookies.
                </p>
              </div>
              <div className="flex items-center gap-3 w-full md:w-auto">
                <button
                  onClick={handleReject}
                  className="flex-1 md:flex-none px-5 py-2.5 text-sm font-medium text-text-muted hover:text-text-primary border border-dark-border hover:border-text-muted rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Rechazar
                </button>
                <button
                  onClick={handleAccept}
                  className="flex-1 md:flex-none px-5 py-2.5 text-sm font-medium text-dark-bg bg-orange-primary hover:bg-orange-secondary rounded-lg transition-all duration-300 hover:shadow-[0_0_20px_rgba(255,106,0,0.3)] whitespace-nowrap cursor-pointer"
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
